module.exports = __webpack_public_path__ + "img/Different-Hair-Loss-Areas3@2x.aa5a7816.jpg";